export const trackerModalSettings={
    labels:{
        buttonLabels:{
            ok: "OK",
            cancel: "Cancel",
        },
        prompt: "Do you want to proceed?",
    }
};

export default trackerModalSettings;